import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    left: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {},
  methods: {
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    getVirtulData: function getVirtulData(year, month, dateData) {
      var dates = year + '-' + month + '-' + '1';
      var today = Date.parse(new Date(dates));
      var dayTime = 3600 * 24 * 1000;
      var thatday = today + dayTime * this.getDaysInOneMonth(year, month);
      var data = [];

      for (var time = today; time < thatday; time += dayTime) {
        data.push([echarts.format.formatTime('yyyy-MM-dd', time), 5]);
      }

      for (var i = 0; i < data.length; i++) {
        data[i][1] = dateData[i];
      }

      return {
        data: data,
        today: echarts.format.formatTime('yyyy-MM-dd', today),
        thatday: echarts.format.formatTime('yyyy-MM-dd', thatday)
      };
    },
    getScatterDate: function getScatterDate(date) {
      //时间戳
      var startTime = +echarts.number.parseDate(date);
      var dayTime = 3600 * 24 * 1000;
      var endTime = startTime + dayTime * this.getDaysInOneMonth(date.split('-')[0], date.split('-')[1]);
      var data = [];

      for (var time = startTime; time < endTime; time += dayTime) {
        //['2020-08-01','01']
        data.push([echarts.format.formatTime('yyyy-MM-dd', time), echarts.format.formatTime('dd', time)]);
      }

      return data;
    },
    initBarChart: function initBarChart(date, label, arr) {
      //获取scatter的data,用于左上角,日的显示
      var scatterData = this.getScatterDate(date); //series的数据初始设置scatter

      var seriesData = [{
        //日期
        id: 'label',
        type: 'scatter',
        coordinateSystem: 'calendar',
        symbolSize: 1,
        label: {
          normal: {
            show: true,
            formatter: function formatter(params) {
              return params.value[1];
            },
            offset: [-30, -30],
            textStyle: {
              color: color2,
              fontSize: 14
            }
          }
        },
        data: scatterData
      }]; //series后续设置pie

      function getPieSeries() {
        scatterData.map(function (item, index) {
          //转换坐标系上的点到像素坐标值,转换的结果为像素坐标值
          var center = myChart.convertToPixel('calendar', item);
          var obj = {};
          var style = {};
          var arrs = [];
          arr[index].forEach(function (item1, index1) {
            obj.name = item1.name;
            obj.value = item1.value;
            style.color = item1.color;
            obj.itemStyle = style;
            arrs.push(obj);
            obj = {};
            style = {};
          });
          var seriesItem = {
            id: index + 'pie',
            type: 'pie',
            center: center,
            label: {
              normal: {
                formatter: '{c}',
                position: 'inside'
              }
            },
            radius: 30,
            data: arrs
          };
          seriesData.push(seriesItem);
        });
      }

      var color1 = '#0a0b58';
      var color2 = '#edebf3';
      var option = {
        backgroundColor: color1,
        legend: {
          data: label,
          bottom: 20,
          textStyle: {
            color: color2
          },
          type: 'scroll'
        },
        tooltip: {
          show: true,
          formatter: function formatter(params) {
            return params.marker + params.data.name + ':' + params.data.value;
          }
        },
        calendar: {
          //日历坐标
          top: 'middle',
          left: 'center',
          orient: 'vertical',
          cellSize: [80, 80],
          splitLine: {
            show: true,
            lineStyle: {
              color: color1
            }
          },
          yearLabel: {
            show: false,
            textStyle: {
              fontSize: 30
            }
          },
          dayLabel: {
            margin: 20,
            firstDay: 1,
            color: color2,
            nameMap: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
          },
          monthLabel: {
            show: false
          },
          range: [date],
          itemStyle: {
            color: color1,
            borderColor: '#2b2e6c'
          }
        },
        series: seriesData
      };
      setTimeout(function () {
        getPieSeries();
        myChart.setOption(option);
      }, 10);
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      myChart.on('click', function (param) {});
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};